<template>
  <div
    class="modal fade border-0"
    id="editUser"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-labelledby="editUserModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content border-0">
        <div class="modal-header shadow-sm ">
          <h6
            class="modal-title font-weight-bold text-light"
            id="changePasswordModalLabel"
          >
            {{
              user ? `Edit User ${models && models.name}` : "Create new user"
            }}
          </h6>
        </div>
        <div class="modal-body ">
          <div class="row m-0">
            <div class="col">
              <div class="form-group">
                <label class="small text-light" for="name">Name</label>
                <input
                  :disabled="isProcessing"
                  autocomplete="chrome-off"
                  type="text"
                  class="form-control form-control-default form-control-sm bg-dark-input"
                  id="name"
                  v-model="models.name"
                />
              </div>
            </div>
          </div>
          <div class="row m-0">
            <div class="col">
              <div class="form-group">
                <label class="small text-light" for="name">Password</label>
                <input
                  :disabled="isProcessing"
                  type="text"
                  class="form-control form-control-default form-control-sm bg-dark-input"
                  id="password"
                  v-model="models.password"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label class="small text-light" for="email">Email</label>
                <input
                  :disabled="isProcessing"
                  type="email"
                  class="form-control form-control-default form-control-sm bg-dark-input"
                  id="email"
                  v-model="models.email"
                />
              </div>
            </div>
          </div>
          <div class="row m-0">
            <div class="col">
              <div class="form-group" v-if="roles.length > 0">
                <label class="small text-light" for="role">Role</label>
                <div class="btn-group w-100">
                  <button
                    type="button"
                    class="btn btn-dark dropdown-toggle w-100"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    :disabled="roles.length == 0 || isProcessing"
                  >
                    {{ models.role ? models.role.name : "Select Role" }}
                  </button>
                  <div class="dropdown-menu dropdown-menu-right w-100">
                    <button
                      class="dropdown-item text-muted w-100"
                      type="button"
                      @click="handleClickRole(null)"
                    >
                      Select Role
                    </button>
                    <button
                      class="dropdown-item text-light w-100"
                      :class="
                        models.role && models.role.name == role.name
                          ? 'bg-primary'
                          : ''
                      "
                      type="button"
                      v-for="role in roles"
                      :key="role.id"
                      @click="handleClickRole(role)"
                    >
                      {{ role.name }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-0">
            <div class="col">
              <div class="form-group" v-if="districts.length > 0">
                <label class="small text-light" for="district">
                  Districts
                </label>
                <div class="btn-group w-100">
                  <button
                    type="button"
                    class="btn btn-dark dropdown-toggle w-100"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    :disabled="districts.length == 0 || isProcessing"
                  >
                    Select District
                  </button>
                  <div class="dropdown-menu dropdown-menu-right w-100">
                    <button
                      class="dropdown-item text-muted w-100"
                      type="button"
                      @click="
                        models = {
                          ...models,
                          districts: [],
                        }
                      "
                    >
                      {{
                        models.districts.length > 0
                          ? "Deselect District"
                          : "Select District"
                      }}
                    </button>
                    <button
                      class="dropdown-item text-light w-100"
                      :class="
                        models.districts.length > 0 &&
                        models.districts.filter((x) => x.id == district.id)
                          .length > 0
                          ? 'bg-primary'
                          : ''
                      "
                      type="button"
                      v-for="district in districts"
                      :key="district.id"
                      @click="handleClickDistrict(district)"
                    >
                      {{ district.name }}
                      <font-awesome-icon
                        v-if="
                          models.districts.length > 0 &&
                          models.districts.filter((x) => x.id == district.id)
                            .length > 0
                        "
                        :icon="['fas', 'check']"
                        class="float-right align-middle"
                      />
                    </button>
                  </div>
                </div>
                <div class="mt-2" v-if="models.districts.length > 0">
                  <p class="small text-muted mb-1">Selected District</p>
                </div>
                <div
                  class="d-flex flex-wrap"
                  v-if="models.districts.length > 0"
                >
                  <span
                    class="bg-warning py-1 px-2 mr-1 mb-1 small rounded"
                    style="cursor: pointer"
                    v-for="d in models.districts"
                    :key="d.id"
                  >
                    <div @click="handleClickDistrict(d)">
                      {{ d.name }}
                      <font-awesome-icon
                        :icon="['fas', 'times']"
                        class="ml-2"
                      />
                    </div>
                  </span>
                </div>
                <div class="mt-4">
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      v-model="models.isCmsUser"
                    />
                    <label
                      class="form-check-label text-light"
                      for="flexSwitchCheckDefault"
                      >CMS Access</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end px-3 mt-3">
            <div
              class="btn bg-dark w-50 mr-3 text-light"
              :disabled="isProcessing"
              @click="closeModal()"
            >
              Cancel
            </div>
            <div
              class="btn btn-primary w-50"
              :disabled="isProcessing"
              @click="save()"
            >
              <div
                v-if="isProcessing"
                class="spinner-border spinner-border-sm mr-2"
                role="status"
              ></div>
              {{ user ? "Save" : "Create" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api";
import Swal from "sweetalert2";

export default {
  name: "edit-user",
  props: ["show", "user", "roles", "districts", "getUsers"],
  data() {
    return {
      isProcessing: false,
      models: {
        name: "",
        password: "",
        email: "",
        role: null,
        districts: [],
        isCmsUser: false,
      },
    };
  },
  computed: {},
  watch: {
    user: {
      handler() {
        if (this.user) {
          this.models = {
            name: this.user.name,
            email: this.user.email,
            role: this.user.role,
            districts: this.user.districts,
            isCmsUser: this.user.isCmsUser,
          };
        }
      },
    },
    show: {
      handler() {
        if (this.show) {
          $("#editUser").modal("show");
        } else {
          $("#editUser").modal("hide");
        }
      },
      immediate: true,
    },
  },
  methods: {
    save() {
      if (!this.models.role) {
        Swal.fire("", "Please select role", "warning");
      } else {
        this.isProcessing = true;
        let payload = {
          ...this.models,
          role: this.models.role.id,
          districts: this.models.districts.map((x) => x.id),
          isCmsUser: this.models.isCmsUser,
        };

        if (!payload.password) delete payload.password;
        if (this.user) {
          API.put(`users/${this.user.id}`, payload)
            .then((result) => {
              this.isProcessing = false;
              this.getUsers();
              this.closeModal();
            })
            .catch((err) => {
              this.isProcessing = false;
              this.getUsers();
              this.closeModal();
            });
        } else {
          API.post(`users`, {
            ...payload,
            username: payload.name,
            confirmed: true,
          })
            .then((result) => {
              this.isProcessing = false;
              this.closeModal();
            })
            .catch((err) => {
              this.isProcessing = false;
              this.closeModal();
            });
        }
      }
    },
    closeModal() {
      if (!this.isProcessing) {
        this.$emit("close");
        this.models = {
          name: "",
          password: "",
          email: "",
          role: null,
          districts: [],
          isCmsUser: false,
        };
      }
    },
    handleClickRole(role) {
      if (role) {
        this.models = {
          ...this.models,
          role,
        };
      }
    },
    handleClickDistrict(district) {
      if (this.models.districts.length > 0) {
        const checking = this.models.districts.filter(
          (x) => x.id == district.id
        );
        if (checking.length > 0) {
          this.models = {
            ...this.models,
            districts: this.models.districts.filter((x) => x.id != district.id),
          };
        } else {
          this.models = {
            ...this.models,
            districts: [...this.models.districts, district],
          };
        }
      } else if (district) {
        this.models = {
          ...this.models,
          districts: [...this.models.districts, district],
        };
      }
    },
  },
};
</script>